import {
  TOGGLE_EMAIL_STEP,
  UPDATE_LOGIN_EMAIL_ERROR,
  UPDATE_LOGIN_IS_FETCHING,
  UPDATE_LOGIN_OR_SIGN_UP,
  UPDATE_LOGIN_PASSWORD_ERROR,
  UPDATE_LOGIN_PLAIN_ERROR,
  UPDATE_NEW_OAUTH,
} from '../constants/actions';

const DEFAULT_LOGIN_STATE = {
  email_error: null,
  is_fetching: false,
  log_in: true,
  new_oauth: false,
  password_error: null,
  plain_error: null,
  email_step: 0,
};

const loginReducer = (state = DEFAULT_LOGIN_STATE, action) => {
  switch (action.type) {
    case UPDATE_LOGIN_EMAIL_ERROR:
      return {
        ...state,
        email_error: action.err,
      };
    case UPDATE_LOGIN_IS_FETCHING:
      return {
        ...state,
        is_fetching: action.isFetching,
      };
    case UPDATE_LOGIN_PASSWORD_ERROR:
      return {
        ...state,
        password_error: action.err,
      };
    case UPDATE_LOGIN_PLAIN_ERROR:
      return {
        ...state,
        plain_error: action.err,
      };
    case UPDATE_NEW_OAUTH:
      return {
        ...state,
        new_oauth: action.newOauth,
      };
    case UPDATE_LOGIN_OR_SIGN_UP:
      return {
        ...state,
        log_in: action.logIn,
      };
    case TOGGLE_EMAIL_STEP:
      return {
        ...state,
        email_step: state.email_step === 0 ? 1 : 0,
      };
    default:
      return state;
  }
};

export default loginReducer;
